import { useTranslation } from "react-i18next";
import { changeLocale, SUPPORTED_LOCALES } from "./index";
import type { SupportedLocale } from "./detectLanguage";

export const useLocale = () => {
  const { i18n, t } = useTranslation();
  const current = (
    SUPPORTED_LOCALES.includes(i18n.language as SupportedLocale)
      ? i18n.language
      : "en"
  ) as SupportedLocale;

  return {
    locale: current,
    setLocale: changeLocale,
    t,
  };
};
